import { type UseQueryResult } from '@tanstack/react-query'
import { type MeResponse } from 'src/types/api'
import { create } from 'zustand'
interface SetMe {
  passedMe: UseQueryResult<MeResponse>
  setPassedMe: (passedMe: UseQueryResult<MeResponse>) => void
}

export const useSetMe = create<SetMe>((set) => ({
  passedMe: {} as unknown as UseQueryResult<MeResponse>,
  setPassedMe: (passedMe: UseQueryResult<MeResponse>) => {
    set({ passedMe })
  },
}))
